import { render } from "./LeaveAdminLegalDocumentsView.vue?vue&type=template&id=2eb08f77&scoped=true"
import script from "./LeaveAdminLegalDocumentsView.vue?vue&type=script&lang=js"
export * from "./LeaveAdminLegalDocumentsView.vue?vue&type=script&lang=js"

import "./LeaveAdminLegalDocumentsView.vue?vue&type=style&index=0&id=2eb08f77&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eb08f77"]])

export default __exports__